import Countdown from "antd/lib/statistic/Countdown";
import moment from "moment-jalaali";
import React from "react";
import styled from "styled-components";
import { devices } from "../../../../../../Utility/Devices";
import DateTime from "../../../../../../Utility/Method/DateTime";

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: ${({ clock = false }) =>
    clock ? `space-evenly` : `center`};
  order: 6;
  @media ${devices.tablet} {
    order: 3;
    align-items: flex-end;
  }
  .clock {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    flex: 1;
  }
`;

function TimeInfo({ data, theme }) {
  const { from, Status } = data.Session;

  const renderTimer = () => {
    return (
      <div className="clock">
        <span className="title">باقیمانده تا شروع کلاس :</span>
        <Countdown
          valueStyle={{
            color: theme.primary,
            fontWeight: 800,
            fontSize: theme.fontSizeMd,
            fontFamily: "inherit",
          }}
          value={Number(moment(from).format("x"))}
          format={`m دقیقه`}
          onFinish={() => window.location.reload()}
        />
      </div>
    );
  };

  if (Status === 3 && DateTime.getDiff(from) < 30) {
    return <Container clock>{renderTimer()}</Container>;
  }

  return (
    <Container>
      {from ? moment(from).format("jYYYY/jMM/jDD - ساعت HH:mm") : null}
    </Container>
  );
}

export default TimeInfo;
